export default __webpack_public_path__ + "static/Outro-3117c85274c7ffab5c6185512a4f69cd.png";